import { Suspense } from "react";
import { Outlet } from "react-router";

const VERSION = import.meta.env.VITE_APP_VERSION;

const LayoutWithoutSidebar = () => {
  return (
    <main>
      <Suspense fallback={null}>
        <Outlet />
      </Suspense>
      <div className="absolute bottom-3 left-3 z-10">
        <div className="text-xs text-gray-400 font-mono">
          v
          {VERSION}
        </div>
      </div>
    </main>
  );
};

export default LayoutWithoutSidebar;
